import { useState, useEffect, useCallback } from 'react'
import { jsPDF } from 'jspdf'
import Loader from 'components/ui/loader/Loader'
import { getCertificateData } from 'api/certificates/Get'
import { ICourseCertificateUser } from 'models/certificate.model'
import GeneratePdf from 'components/reusables/generatePdf'
import styles from './Generate.module.scss'

interface GenerateProps {
  certificateId: string
  courseId: number | string
}

const Generate = ({ certificateId, courseId }: GenerateProps) => {
  const [certificate, setCertificate] = useState<ICourseCertificateUser | null>(
    null
  )

  const getCertificate = useCallback(async () => {
    const data = await getCertificateData({
      certificateId,
      courseId: courseId.toString() === '0' ? null : courseId,
    })
    setCertificate(data.data.data.attributes)
  }, [certificateId, courseId])

  useEffect(() => {
    getCertificate()
  }, [getCertificate])

  const onGenerate = (pdf: jsPDF | null) => {
    if (pdf) {
      pdf.save(
        `${certificate?.user.fullName} (${certificate?.user.identifier}).pdf`,
        { returnPromise: true }
      )
    }
    setTimeout(() => window.close(), 1000)
  }

  return (
    <div>
      <Loader overlay color className={styles.overlay} />
      {certificate && (
        <GeneratePdf
          content={certificate.template.html}
          backgroundImage={certificate.template.bgImage}
          onGenerate={onGenerate}
        />
      )}
    </div>
  )
}

export default Generate
